// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_modules_audit_audit_module_ts":"42680baec8c2244e","src_app_modules_Configuration_configuration_module_ts":"d2fb88cfd5300a6b","src_app_modules_request_request_module_ts":"c29171ec6decb784"}[chunkId] + ".js";
};